<template>
  <li class="listitem">
    <div>
      <a :href="listItem.url">
        <SistaOrdet
          :text="listItem.title"
          :arrowToLeft="$arrowToLeft"
        ></SistaOrdet>
      </a>
    </div>
  </li>
</template>

<script>
import SistaOrdet from "../../helpers/sistaordet.vue";

export default {
  name: "ListItem",
  props: {
    listItem: Object,
  },
  components: {
    SistaOrdet,
  },
};
</script>
